export const COLORS = [
    '#0064F9', 
    '#7400F9',
    '#407ee2', 
    '#5dcbfd', 
    '#22d9cb',

    "#4FC3F7", // Sky Blue
    "#2979FF", // Royal Blue
    "#3F51B5", // Indigo Blue
    "#009688", // Teal
    "#4DB6AC", // Aqua Mint
    "#2E7D32", // Sea Green
    "#43A047", // Emerald Green
    "#9575CD", // Soft Violet
    "#673AB7", // Deep Purple
    "#BA68C8", // Orchid
];

